__turbopack_context__.v({
  "actions": "kzU0-G_actions",
  "amountInput": "kzU0-G_amountInput",
  "calculatedAmount": "kzU0-G_calculatedAmount",
  "causeAreas": "kzU0-G_causeAreas",
  "distributionCauseAreaInputContainer": "kzU0-G_distributionCauseAreaInputContainer",
  "distributionCauseAreaInputHeader": "kzU0-G_distributionCauseAreaInputHeader",
  "distributionCauseAreaInputPercentageShare": "kzU0-G_distributionCauseAreaInputPercentageShare",
  "errorWrapper": "kzU0-G_errorWrapper",
  "multiLayout": "kzU0-G_multiLayout",
  "percentageInput": "kzU0-G_percentageInput",
  "singleCauseAreaDistribution": "kzU0-G_singleCauseAreaDistribution",
  "textWrapper": "kzU0-G_textWrapper",
  "values": "kzU0-G_values",
  "valuesAmountContainer": "kzU0-G_valuesAmountContainer",
  "valuesDatePickerContainer": "kzU0-G_valuesDatePickerContainer",
  "valuesSmartDistributionToggle": "kzU0-G_valuesSmartDistributionToggle",
  "valuesTaxUnitSelectorContainer": "kzU0-G_valuesTaxUnitSelectorContainer",
  "wrapper": "kzU0-G_wrapper",
});
